class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.announcementBar = this.querySelector("#wt-announcement__container");
    this.items = this.announcementBar
      ? this.announcementBar.querySelectorAll(".wt-announcement__fade-item")
      : [];
    this.fadeSpeed =
      (Number(this.announcementBar?.dataset.fadeSpeed) || 4) * 1000;
    this.announcementInterval = null;

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
  }

  connectedCallback() {
    if (this.items.length > 1) {
      this.announcementInterval = setInterval(
        this.changeAnnouncement,
        this.fadeSpeed,
      );

      this.announcementBar.addEventListener(
        "touchstart",
        this.handleTouchStart,
        { passive: true },
      );
      this.announcementBar.addEventListener("touchmove", this.handleTouchMove, {
        passive: true,
      });
      this.announcementBar.addEventListener("touchend", this.handleTouchEnd, {
        passive: true,
      });
    }

    this.closeButton = this.querySelector(".wt-announcement__close");
    if (this.closeButton)
      this.closeButton.addEventListener("click", this.hideForOneDay);
  }

  setActiveItem(index) {
    this.items[this.currentIndex]?.classList.remove("is-active");
    this.currentIndex = index;
    this.items[this.currentIndex]?.classList.add("is-active");
  }

  restartInterval() {
    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(
      this.changeAnnouncement,
      this.fadeSpeed,
    );
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  changeAnnouncement() {
    this.setActiveItem((this.currentIndex + 1) % this.items.length);
  }

  previousAnnouncement() {
    this.setActiveItem(
      (this.currentIndex - 1 + this.items.length) % this.items.length,
    );
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
    this.touchEndX = this.touchStartX;
    clearInterval(this.announcementInterval);
  }

  handleTouchMove(e) {
    this.touchEndX = e.touches[0].clientX;
  }

  handleTouchEnd() {
    const swipeThreshold = 30;

    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement();
      } else {
        this.previousAnnouncement();
      }
    }

    this.restartInterval();
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);
    if (this.announcementBar) {
      this.announcementBar.removeEventListener(
        "touchstart",
        this.handleTouchStart,
      );
      this.announcementBar.removeEventListener("touchmove", this.handleTouchMove);
      this.announcementBar.removeEventListener("touchend", this.handleTouchEnd);
    }
  }
}

customElements.define("announcement-bar", AnnouncementBar);
